import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { set_isDirty } from "redux/actions/AppActions";

const Confirmation = (props) => {

    const i18n = useTranslation()
    const dispatch=useDispatch()
    const {
        open = false,
        setOpen,
        callback = new Function(),
        message = '',
        title = `${i18n.t('appointments.ARE_YOU_SURE')}`,
        type=''
    } = props;

    const handleClose = () => {
        setOpen(false);
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={()=>{
                    if(type=='cancelConfirmation'){
                        new Function()
                    }else{
                        handleClose()
                    }
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    minHeight: '400px'
                }}
            >
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {
                            type=='cancelConfirmation'?
                            `${i18n.t('common.YOU_HAVE_SOME_UNSAVED_WORK_DO_YOU_STILL_WANT_TO_LEAVE_THE_PAGE')} ?`:
                            message
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button 
                        variant="text" 
                        size="large" 
                        onClick={handleClose}
                    >
                       {
                        type=='cancelConfirmation'?
                        i18n.t('common.GO_BACK'):
                        type=='appointmentCancellation'?
                        i18n.t('common.GO_BACK'):
                        i18n.t('common.CANCEL')
                       }
                    </Button>
                    <Button 
                        variant="text"
                        size="large" 
                        onClick={ () => {
                            callback();
                            dispatch(set_isDirty(false))
                            setOpen(false);
                        }}
                    >
                        {
                            type=='cancelConfirmation'?
                            i18n.t('common.YES_LEAVE'):
                            type=='appointmentCancellation'?
                            i18n.t('common.YES_CANCEL'):
                            i18n.t('common.OK')
                        }
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default Confirmation;